// extracted by mini-css-extract-plugin
export default {"container":"Basketball_container__r26mH","score":"Basketball_score__bPd0A","team":"Basketball_team__1ab7J","teamName":"Basketball_teamName__+gfV9"};